// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import * as VueGoogleMaps from "vue2-google-maps"
import App from './App'
import router from './router'
import VueFire from 'vuefire'
import { auth } from '@/config/devowqlo';

Vue.use(VueFire)

// todo
// cssVars()

Vue.use(BootstrapVue)
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBnF10ORfovm2WLYQjnxp9hycIjXMRpX48",
    libraries: "places" // necessary for places input
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  created() {
    //auth.signOut();
    auth.onAuthStateChanged((user) => {
      if (user) {
        console.log(user)
        console.log(user.email)
        user.getIdTokenResult()
          .then((idTokenResult) => {
            // Confirm the user is an Admin.
            console.log(idTokenResult.claims)
            if (!!idTokenResult.claims['superadmin']) {
              // Show admin UI.
              //Go to main page
              console.log("keep going page")
              this.$router.push('/dashboard')
            } else {
              // Show regular user UI.
              console.log("go to login page")
              this.$router.push('/auth')
              //auth.signOut();
            }
          })
          .catch((error) => {
            console.log(error);
          });
        
      }else{
        console.log("go to login page")
        this.$router.push('/auth')
      }
    });
  },
  template: '<App/>',
  components: {
    App
  }
})
